// extracted by mini-css-extract-plugin
export default {"main":"CausaNoValidoSelector_main__Zjmtg"};